import { Grid } from "../../core/components/grid";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { Config } from "../../core/config/config";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { DialogHelper } from "../../core/util/dialogHelper";
import { FavoriteFilterHelper} from "../../favoriteFilter/editFavoriteFilter";
import React from "react";
export default class FavoriteFilter extends React.Component<any, {gridData: any[]}> {
    private buttons: Array<ToolBarStandardButton> = [
        {
            caption: Config.translations.newLabel,
            type: ToolBarStandardButtonType.NEW,
            enabled: true
        },
        {
            caption: Config.translations.editLabel,
            type: ToolBarStandardButtonType.EDIT,
            enabled: true
        },
        {
            caption: Config.translations.deleteLabel,
            type: ToolBarStandardButtonType.DELETE,
            enabled: true
        }
    ];
    constructor(props) {
        super(props)
        this.state = {
            gridData: []
        }
        this.loadGridData();
    }

    private loadGridData = async () => {
        const result = await HTTPService.get<JsonResultClass>("FavoriteFilter/GetAll");
        this.setState({ gridData: result.Data })
    } 


    private renderGrid = () => {
        return (
            <div className="flex-container" style={{ height: "350px" }}>
                <Grid
                    data={this.state.gridData}
                    options={this.props.field.gridOptions}
                    standardButtons={this.buttons}
                    onClickStandardButton={this.onButtonClick}
                    id="GeneralSettings_FF_Grid"
                />
            </div>
        );
    }

    private onButtonClick = async (type: ToolBarStandardButtonType, dataItem: { Id: string }) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                await FavoriteFilterHelper.createGlobal();
                this.loadGridData();
                break;
            case ToolBarStandardButtonType.EDIT:
                await FavoriteFilterHelper.editFavorite(dataItem.Id, true);
                this.loadGridData();
                break;
            case ToolBarStandardButtonType.DELETE:
                const ok = await DialogHelper.confirm(__internal_translations["Standard.Msg.Loeschen"]);
                if (ok) {
                    await FavoriteFilterHelper.delete(dataItem.Id)
                    this.loadGridData();
                }
                break;
        }

    }


    render() {
        return this.renderGrid();
    }
}